import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
//#region src/redux/notification/reducers.ts
var reducers_exports = /* @__PURE__ */ __exportAll({
	clear: () => clear,
	show: () => show
});
var show = (state, { payload }) => {
	state.notification = payload;
};
var clear = (state) => {
	state.notification = null;
};
//#endregion
export { clear, reducers_exports, show };

//# sourceMappingURL=reducers.js.map